const objectHelper = {
    mergeTo: (objSource, objDestination = {}) => {
        if (objSource)
            Object.keys(objSource).forEach(k => objDestination[k] = objSource[k]);

        return objDestination;
    }
}

export default objectHelper;